module.exports = __webpack_public_path__ + "img/img.151be52c.jpg";